export default __webpack_public_path__ + "static/media/followers.b7797a6b.svg";